module.exports = __webpack_public_path__ + "static/media/girl-studying.a7cd9ae5.svg";